const colombia = {
    baseDomain: 'https://cms-dot-stunning-base-164402.uc.r.appspot.com/backend/flexible/v2/',
    marketingDomain: 'https://banners---ftd-td-marketing-services-33aylvwcgq-uc.a.run.app/marketing-ds/v1/co/',
    properties: 'https://multicountry-apigateway-dot-stunning-base-164402.uc.r.appspot.com/algolia/v1/properties',
    redisClear: 'redis/v1/properties',
    // utilities: 'https://utilities-dot-dev-domicilios-farmatodo.uk.r.appspot.com/',
    utilities: 'https://utilities-dot-stunning-base-164402.uc.r.appspot.com/',
    algoliaConf : {
        envs: {
            prod: {
                id: 'VCOJEYD2PO',
                key: '94b6dd4374927e6ac2046497c2fe791c',
                index: 'products',
                properties: 'properties',
                propierties: {
                    timePromTickets: 'TIME_PROM_TICKETS_COL'
                },
                items_seo: 'items_seo'
            },
            dev: {
                id: 'testingYA3RG061BL',
                key: '3884ebb0619b13dcec74002f555c8990',
                index: 'products',
                properties: 'properties',
                items_seo: 'items_seo'
            }
        },
    },
    isColombia: true,
};

const venezuela = {
    baseDomain: 'https://cms-dot-oracle-services-vzla.uc.r.appspot.com/backend/flexible/v2/',
    marketingDomain: 'https://banners---ftd-td-marketing-services-33aylvwcgq-uc.a.run.app/marketing-ds/v1/ve/',
    properties: 'https://multicountry-apigateway-dot-stunning-base-164402.uc.r.appspot.com/algolia/v1/properties',
    utilities: 'https://utilities-vlza-dot-oracle-services-vzla.uc.r.appspot.com/',
    algoliaConf: {},
    isVenezuela: true,
};

// Descomentar cuando el país sea Colombia
export { colombia as countryConfig };

// Descomentar cuando el país sea Venezuela
//export { venezuela as countryConfig };
